module.exports = __webpack_public_path__ + "static/media/good-selected.4b575e71.svg";